import PropTypes from 'prop-types';
import React from 'react';

const MainContent = ({ children }) => {
  return (
    <main
      id="cm-main-content"
      className="flex flex-col flex-1 md:border-l text-gray-700 h-[inherit] overflow-x-auto"
    >
      {children}
    </main>
  );
};

MainContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainContent;
